(function () {
  'use strict';

  angular
    .module('vcexamtemplate')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.examtemplate', {
        url: '/examtemplate',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;examtemplatenew&gt;</tt></h3><div ui-view="examtemplatenewview"></div>
              <!--<h3 class="alert alert-info"><tt>&lt;examtemplateeditor examtemplate="" onClose=""&gt;</tt></h3><div ui-view="examtemplateeditview"></div>-->
              <h3 class="alert alert-info"><tt>&lt;examtemplatelist examtemplates="?"&gt;</tt></h3><div ui-view="examtemplatelistview"></div>
            `
          }
        },
        onEnter: function ($log) {
          $log.debug('debug/routes - playground.vcexamtemplate entered');
        }
      });
    
    
    $stateProvider
      .state('playground.examtemplate.allcomponents', {
        url: '/allcomponents',
        resolve: {
          examtemplate: function (ExamtemplateHelper) {
            return ExamtemplateHelper.getSampleTemplate();
          },
          examtemplateref: function () {
            return '';
          },
          someexamtemplate: function (Examtemplate) {
            return Examtemplate.$find('572b31b07c01597e3e150923');
          },
          allexamtemplates: function (Examtemplate) {
            return Examtemplate.$search();
          },
          parentsavesearch: function () {
            return function (examtemplate, examtemplateref) {
              console.log('debug: dummy parentsave called for examtemplatesearch with: ', examtemplate, examtemplateref);
            };
          },
          eip: function () {
            return true;
          }
        },
        views: {
          'examtemplatesearchview@playground.examtemplate': {
            component: 'examtemplatesearch',
            bindings: {
              examtemplate: 'examtemplate',
              examtemplateref: 'examtemplateref',
              editinplace: 'eip'
            }
          },
          'examtemplatenewview@playground.examtemplate': {
            component: 'examtemplatenew',
            bindings: {
            }
          }/*,
          'examtemplateeditview@playground.examtemplate': {
            component: 'examtemplateeditor',
            bindings: {
              examtemplate: 'someexamtemplate'
            }
          },
          'examtemplatenewview@playground.examtemplate': {
            component: 'examtemplatenew',
            bindings: {
            }
          }*/,
          'examtemplatelistview@playground.examtemplate': {
            component: 'examtemplatelist',
            bindings: {
              examtemplates: 'allexamtemplates'
            }
          }
        },
        onEnter: function () {
          console.log('playground.examtemplate.allcomponents entered');
        }
      });
    
    
  }// all routes
  
  
}());






